module.exports = __webpack_public_path__ + "img/living_thumbnail.1e6894ea.jpg";